import React from 'react';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import clsx from 'clsx';
import { Button } from '@material-ui/core';

import logo from '@root/assets/shopify-logo.png';
import integrationResource from '@root/resources/integrations';

import useStyles from './ShopifyConnectForm.styles';
import SuccessScreen from './SuccessScreen';

const validationSchema = yup.object({
  shopify: yup
    .string('Enter your shopify url')
    .required('The example URL must be provided')
    .matches(
      /^[a-zA-Z]+:\/\/.*:.*@.*\..*\..*\/([a-zA-Z]+(\.[a-zA-Z]+)+)$/i,
      'Must be in the exact same form provided by Shopify',
    ),
});

const ShopifyConnectForm = ({ close }) => {
  const { mutateAsync: createIntegration } = integrationResource.useCreateIntegration();
  const { mutateAsync: updateIntegration } = integrationResource.useUpdateIntegration();
  const [isInstalled, setIsInstalled] = React.useState(false);

  const submit = async (values) => {
    const { shopify: connectionUrl } = values;

    const { _id: id } = await createIntegration({ type: 'shopify' });
    const str2 = connectionUrl.slice(8).split(':', 2);
    const apiKey = str2[0];
    const str3 = str2[1].split('@', 2);
    const password = str3[0];
    const str4 = str3[1].split('.', 2);
    const subdomain = str4[0];
    await updateIntegration({
      id,
      data: { apiKey, password, subdomain },
      status: 'active',
    });
    setIsInstalled(true);
  };

  const onClose = () => {
    close();
  };

  const classes = useStyles();

  return (
    <div className={classes.form}>
      <div className={classes.header}>
        <img
          src={logo}
          alt="Shopify Logo"
          width="138px"
        />
        <div className={classes.verticalLine} />
        <div className={classes.text}>
          Connect
        </div>
      </div>
      {isInstalled ? (
        <div className={classes.root}>
          <SuccessScreen close={onClose} />
        </div>
      ) : (
        <>
          <div>
            Enter your API key to connect your Shopify store to your Copysmith account.
          </div>
          <Formik
            initialValues={{
              shopify: '',
            }}
            validationSchema={validationSchema}
            onSubmit={submit}
          >
            {({
              handleChange,
              handleBlur,
              handleSubmit,
              isValid,
              errors,
              touched,
            }) => {
              const invalidInput = touched.shopify && errors.shopify;
              return (
                <Form>
                  <div>
                    Example URL
                    <input
                      title="Example URL"
                      type="text"
                      name="shopify"
                      label="Shopify"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      autoComplete="off"
                      className={clsx({ [classes.inputError]: invalidInput },
                        classes.input)}
                    />
                    {invalidInput && (
                      <div className={classes.errorMessage}>
                        {errors.shopify}
                      </div>
                    )}
                    <Button
                      onClick={handleSubmit}
                      type="submit"
                      disabled={!isValid}
                      className={classes.connectButton}
                    >
                      Connect Shopify Store
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </>
      )}
    </div>
  );
};

export default ShopifyConnectForm;
